const state = {
  refreshFlag: false
}

const getters = {
  getRefreshFlag: state => state.refreshFlag
}

const mutations = {
  setRefreshFlag (state) {
    state.refreshFlag = !state.refreshFlag
  }
}

const actions = {
}

export default { namespaced: true, state, mutations, actions, getters }
